import { render, staticRenderFns } from "./FixationChooseHandler.vue?vue&type=template&id=5cd1058a&scoped=true&"
import script from "./FixationChooseHandler.vue?vue&type=script&lang=js&"
export * from "./FixationChooseHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1058a",
  null
  
)

export default component.exports